module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/widget-detail-dashboard/widget-detail-dashboard.component.scss
// module id = ./src/app/widgets/widget-detail/widget-detail-dashboard/widget-detail-dashboard.component.scss
// module chunks = main